module.exports = __webpack_public_path__ + "img/subscribeKing.82135b69.png";